/* ==========================================================================
   Current. — Contour Collection landing page
   Shared script for the contour-* sections. Loaded once per page.

   Terrain source for every glass, in order:
     1. product.metafields.custom.terrain_data  (crnt1: encoded 48x48 grid)
     2. a gentle procedural stand-in (logged to the console so gaps are easy to find)
   ========================================================================== */
(function () {
  'use strict';
  if (window.ContourCC) { window.ContourCC.scan(document); return; }

  var CC = window.ContourCC = { explorers: [] };
  var THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var threeP = null;

  function warn(m) { if (window.console && console.warn) console.warn('[Current. contour] ' + m); }
  function loadThree() {
    if (window.THREE) return Promise.resolve(window.THREE);
    if (!threeP) threeP = new Promise(function (res, rej) {
      var urls = [THREE_URL, 'https://cdn.jsdelivr.net/npm/three@0.128.0/build/three.min.js'];
      (function next() {
        var u = urls.shift(); if (!u) { rej(new Error('three.js could not be loaded')); return; }
        var s = document.createElement('script'); s.src = u; s.async = true;
        s.onload = function () { window.THREE ? res(window.THREE) : next(); };
        s.onerror = function () { warn('could not load ' + u + ', trying the next copy'); next(); };
        document.head.appendChild(s);
      })();
    });
    return threeP;
  }
  function json(el) { try { return JSON.parse(el.textContent); } catch (e) { warn('could not read section data'); return null; } }
  function cssVar(el, name, fb) { var v = getComputedStyle(el).getPropertyValue(name).trim(); return v || fb; }

  /* ------------------------------------------------------------------ terrain */
  function mulberry32(a) { return function () { a |= 0; a = (a + 0x6D2B79F5) | 0; var t = Math.imul(a ^ (a >>> 15), 1 | a); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }; }
  function decode(str) {
    if (!str || typeof str !== 'string') return null;
    str = str.trim();
    if (str.indexOf('crnt1:') !== 0) return null;
    try {
      var bin = atob(str.slice(6).replace(/\s+/g, '')), n = bin.length, b = new Uint8Array(n), r = mulberry32(0x43524E54);
      for (var i = 0; i < n; i++) b[i] = bin.charCodeAt(i) ^ (Math.floor(r() * 256) & 255);
      if (b[0] !== 1) return null;
      var G = b[1], L = b[2];
      if (!G || n < 3 + G * G) return null;
      var H = new Float32Array(G * G);
      for (var k = 0; k < G * G; k++) H[k] = b[3 + k] / (L - 1);
      return { G: G, H: H };
    } catch (e) { return null; }
  }
  function hash(x, y, s) { var h = Math.sin(x * 127.1 + y * 311.7 + s * 74.7) * 43758.5453; return h - Math.floor(h); }
  function vnoise(x, y, s) { var xi = Math.floor(x), yi = Math.floor(y), xf = x - xi, yf = y - yi, u = xf * xf * (3 - 2 * xf), v = yf * yf * (3 - 2 * yf); var a = hash(xi, yi, s), b = hash(xi + 1, yi, s), c = hash(xi, yi + 1, s), d = hash(xi + 1, yi + 1, s); return a + (b - a) * u + (c - a) * v + (a - b - c + d) * u * v; }
  function fbm(x, y, s) { var t = 0, a = .5, f = 1; for (var i = 0; i < 4; i++) { t += a * vnoise(x * f, y * f, s); f *= 2; a *= .5; } return t / .9375; }

  function Terrain(str, label, seed) {
    this.d = decode(str);
    this.seed = seed || 1;
    if (!this.d) warn((label || 'a glass') + ': ' + (str ? 'terrain_data could not be decoded (check the full crnt1: string was pasted)' : 'no terrain_data metafield, showing a placeholder shape'));
    this.real = !!this.d;
    this.max = 1;
    var m = 0;
    for (var i = 0; i <= 40; i++) for (var j = 0; j <= 40; j++) { var v = this.raw(-1 + i / 20, -1 + j / 20); if (v > m) m = v; }
    this.max = m || 1;
  }
  Terrain.prototype.raw = function (x, z) {
    if (this.d) {
      var G = this.d.G, H = this.d.H, u = (x * .5 + .5) * (G - 1), v = (z * .5 + .5) * (G - 1);
      if (u < 0) u = 0; if (v < 0) v = 0; if (u > G - 1) u = G - 1; if (v > G - 1) v = G - 1;
      var i0 = Math.floor(u), j0 = Math.floor(v), i1 = Math.min(G - 1, i0 + 1), j1 = Math.min(G - 1, j0 + 1), fu = u - i0, fv = v - j0;
      var a = H[j0 * G + i0], b = H[j0 * G + i1], c = H[j1 * G + i0], d = H[j1 * G + i1];
      return a + (b - a) * fu + (c - a) * fv + (a - b - c + d) * fu * fv;
    }
    var r2 = x * x + z * z, h = Math.pow(Math.max(0, 1 - r2 / .8), 1.4) * .9 + .14 * (fbm(x * 2.6 + 5, z * 2.6 + 5, this.seed) - .5);
    return Math.max(0, h) * Math.max(0, Math.min(1, (1 - Math.sqrt(r2)) / .12));
  };
  Terrain.prototype.at = function (x, z) { return this.raw(x, z) / this.max; };
  Terrain.prototype.profile = function (N) {
    var out = [];
    for (var i = 0; i <= N; i++) {
      var x = -1 + 2 * i / N, m = 0;
      for (var z = -1; z <= 1.0001; z += .04) { if (x * x + z * z > 1) continue; var h = this.at(x, z); if (h > m) m = h; }
      out.push(m);
    }
    return out;
  };
  /* marching-squares contours, returned as an SVG path in the -1..1 square */
  Terrain.prototype.contourPath = function (levels) {
    var M = 64, S = [], i, j, d = '';
    for (j = 0; j <= M; j++) for (i = 0; i <= M; i++) S.push(this.at(-1 + 2 * i / M, -1 + 2 * j / M));
    function g(i) { return (-1 + 2 * i / M); }
    function f(n) { return n.toFixed(3); }
    for (var l = 1; l <= levels; l++) {
      var L = l / (levels + 1);
      for (j = 0; j < M; j++) for (i = 0; i < M; i++) {
        var a = S[j * (M + 1) + i], b = S[j * (M + 1) + i + 1], c = S[(j + 1) * (M + 1) + i + 1], e = S[(j + 1) * (M + 1) + i];
        var idx = (a > L ? 8 : 0) | (b > L ? 4 : 0) | (c > L ? 2 : 0) | (e > L ? 1 : 0);
        if (idx === 0 || idx === 15) continue;
        var x0 = g(i), x1 = g(i + 1), z0 = g(j), z1 = g(j + 1);
        var lp = function (p, q, vp, vq) { return p + (q - p) * ((L - vp) / ((vq - vp) || 1e-6)); };
        var T = [lp(x0, x1, a, b), z0], R = [x1, lp(z0, z1, b, c)], B = [lp(x0, x1, e, c), z1], Lf = [x0, lp(z0, z1, a, e)];
        var segs = { 1: [Lf, B], 14: [Lf, B], 2: [B, R], 13: [B, R], 3: [Lf, R], 12: [Lf, R], 4: [T, R], 11: [T, R], 6: [T, B], 9: [T, B], 7: [Lf, T], 8: [Lf, T], 5: [Lf, T, B, R], 10: [T, R, Lf, B] }[idx];
        for (var k = 0; k < segs.length; k += 2) d += 'M' + f(segs[k][0]) + ' ' + f(segs[k][1]) + 'L' + f(segs[k + 1][0]) + ' ' + f(segs[k + 1][1]);
      }
    }
    return d;
  };
  CC.Terrain = Terrain;

  /* polar mesh, matching the round glass base */
  var RINGS = 46, SEGS = 128, MESH = null;
  function mesh() {
    if (MESH) return MESH;
    var n = 1 + RINGS * SEGS, pos = new Float32Array(n * 3), xs = new Float32Array(n), zs = new Float32Array(n), tri = [], lin = [], i, j;
    for (i = 1; i <= RINGS; i++) for (j = 0; j < SEGS; j++) { var a = j / SEGS * Math.PI * 2, id = 1 + (i - 1) * SEGS + j, r = i / RINGS; xs[id] = r * Math.cos(a); zs[id] = r * Math.sin(a); pos[id * 3] = xs[id]; pos[id * 3 + 2] = zs[id]; }
    for (j = 0; j < SEGS; j++) { tri.push(0, 1 + j, 1 + (j + 1) % SEGS); if (j % 4 === 0) lin.push(0, 1 + j); }
    for (i = 1; i < RINGS; i++) for (j = 0; j < SEGS; j++) {
      var A = 1 + (i - 1) * SEGS + j, B = 1 + (i - 1) * SEGS + (j + 1) % SEGS, C = 1 + i * SEGS + j, D = 1 + i * SEGS + (j + 1) % SEGS;
      tri.push(A, C, B, B, C, D); if (i % 2 === 0) lin.push(A, B); if (j % 4 === 0) lin.push(A, C);
    }
    var o = 1 + (RINGS - 1) * SEGS; for (j = 0; j < SEGS; j++) lin.push(o + j, o + (j + 1) % SEGS);
    MESH = { n: n, pos: pos, xs: xs, zs: zs, tri: tri, lin: lin };
    return MESH;
  }
  function heights(t) { var m = mesh(), a = new Float32Array(m.n); for (var i = 0; i < m.n; i++) a[i] = t.at(m.xs[i], m.zs[i]); return a; }

  /* --------------------------------------------------------------- three.js */
  var VS = 'attribute float aH;attribute float aH2;uniform float uMix;uniform float uAmp;varying float vH;varying vec3 vP;void main(){float h=mix(aH,aH2,uMix);vH=h;vec3 p=vec3(position.x,h*uAmp,position.z);vP=p;gl_Position=projectionMatrix*modelViewMatrix*vec4(p,1.0);}';
  var FS_FILL = 'uniform float uContour;uniform float uFill;uniform float uN;uniform vec3 uA;uniform vec3 uB;uniform vec3 uL;varying float vH;varying vec3 vP;void main(){float f=vH*uN;float w=fwidth(f);float g=abs(fract(f-0.5)-0.5)/max(w,1e-4);float line=(1.0-min(g,1.0))*smoothstep(0.04,0.09,vH);vec3 n=normalize(cross(dFdx(vP),dFdy(vP)));float sh=0.5+0.5*abs(dot(n,normalize(vec3(0.4,1.0,0.3))));vec3 base=mix(uA,uB,vH)*sh;float a=uFill;vec3 col=mix(base,uL,line*uContour);a=max(a,line*uContour);if(a<0.01)discard;gl_FragColor=vec4(col,a);}';
  var FS_LINE = 'uniform float uAlpha;uniform vec3 uA;uniform vec3 uB;varying float vH;void main(){gl_FragColor=vec4(mix(uA,uB,vH),uAlpha*(0.35+0.65*vH));}';
  var VS_GLASS = 'varying vec3 vN;varying vec3 vV;void main(){vec4 mv=modelViewMatrix*vec4(position,1.0);vN=normalize(normalMatrix*normal);vV=-mv.xyz;gl_Position=projectionMatrix*mv;}';
  var FS_GLASS = 'uniform float uAlpha;uniform vec3 uC;varying vec3 vN;varying vec3 vV;void main(){float f=pow(1.0-abs(dot(normalize(vN),normalize(vV))),2.4);gl_FragColor=vec4(uC,uAlpha*(0.04+0.75*f));}';

  function makeTerrain(THREE, h0, c) {
    var m = mesh(), P = new THREE.BufferAttribute(m.pos, 3), a1 = new THREE.BufferAttribute(new Float32Array(h0), 1), a2 = new THREE.BufferAttribute(new Float32Array(h0), 1);
    function geo(idx) { var g = new THREE.BufferGeometry(); g.setAttribute('position', P); g.setAttribute('aH', a1); g.setAttribute('aH2', a2); g.setIndex(idx); return g; }
    var sh = { uMix: { value: 1 }, uAmp: { value: .5 } };
    var fu = { uMix: sh.uMix, uAmp: sh.uAmp, uContour: { value: 0 }, uFill: { value: 0 }, uN: { value: 14 }, uA: { value: new THREE.Color(c.fillLow) }, uB: { value: new THREE.Color(c.fillHigh) }, uL: { value: new THREE.Color(c.contour) } };
    var lu = { uMix: sh.uMix, uAmp: sh.uAmp, uAlpha: { value: 1 }, uA: { value: new THREE.Color(c.lineLow) }, uB: { value: new THREE.Color(c.lineHigh) } };
    var fill = new THREE.Mesh(geo(m.tri), new THREE.ShaderMaterial({ vertexShader: VS, fragmentShader: FS_FILL, uniforms: fu, transparent: true, depthWrite: false, side: THREE.DoubleSide, extensions: { derivatives: true } }));
    var lines = new THREE.LineSegments(geo(m.lin), new THREE.ShaderMaterial({ vertexShader: VS, fragmentShader: FS_LINE, uniforms: lu, transparent: true, depthWrite: false }));
    fill.frustumCulled = lines.frustumCulled = false;
    var grp = new THREE.Group(); grp.add(fill); grp.add(lines);
    var rp = []; for (var i = 0; i <= 128; i++) { var a = i / 128 * Math.PI * 2; rp.push(new THREE.Vector3(Math.cos(a), 0, Math.sin(a))); }
    var ring = new THREE.Line(new THREE.BufferGeometry().setFromPoints(rp), new THREE.LineBasicMaterial({ color: new THREE.Color(c.lineLow), transparent: true, opacity: .5 }));
    grp.add(ring);
    return {
      group: grp, shared: sh, fill: fu, line: lu, ring: ring,
      morphTo: function (h) { var A = a1.array, B = a2.array, t = sh.uMix.value; for (var i = 0; i < A.length; i++) A[i] = A[i] + (B[i] - A[i]) * t; B.set(h); a1.needsUpdate = a2.needsUpdate = true; sh.uMix.value = 0; }
    };
  }
  function renderer(THREE, canvas) {
    try { var r = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true }); r.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2)); r.setClearColor(0, 0); return r; } catch (e) { return null; }
  }
  function fit(r, cam, el) { var w = el.clientWidth, h = el.clientHeight; if (!w || !h) return; r.setSize(w, h, false); cam.aspect = w / h; cam.updateProjectionMatrix(); }
  /* The element that actually scrolls the page. Usually the window, but some themes
     (Horizon on desktop, >=990px) scroll an inner wrapper such as .page-wrapper instead. */
  function scroller(el) {
    for (var n = el && el.parentElement; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      var oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && n.scrollHeight > n.clientHeight + 1) return n;
    }
    return null;
  }
  CC.scroller = scroller;
  /* scroll events from any container reach a capturing listener on document */
  function onScroll(fn) {
    document.addEventListener('scroll', fn, { passive: true, capture: true });
    addEventListener('resize', fn, { passive: true });
    return function () { document.removeEventListener('scroll', fn, { capture: true }); removeEventListener('resize', fn); };
  }
  function scrollByY(el, dy) {
    var sc = scroller(el), opt = { top: dy, behavior: reduce ? 'auto' : 'smooth' };
    if (sc) sc.scrollBy(opt); else window.scrollBy(opt);
  }
  function onScreen(el, cb) {
    if (!('IntersectionObserver' in window)) { cb(true); return; }
    new IntersectionObserver(function (e) { cb(e[0].isIntersecting); }, { root: scroller(el), rootMargin: '200px' }).observe(el);
  }
  function palette(el) {
    return {
      lineLow: cssVar(el, '--cc-line-low', '#4f7a88'), lineHigh: cssVar(el, '--cc-line-high', '#f4f1ea'),
      fillLow: cssVar(el, '--cc-fill-low', '#24404a'), fillHigh: cssVar(el, '--cc-fill-high', '#cfe3ea'),
      contour: cssVar(el, '--cc-contour', '#e6f3f7'), glass: cssVar(el, '--cc-glass', '#e0f2f7')
    };
  }
  function loop(state, fn) {
    var last = performance.now();
    (function frame(now) {
      if (state.stopped) return;
      requestAnimationFrame(frame);
      if (!state.on) { last = now; return; }
      var dt = Math.min(.05, (now - last) / 1000); last = now; fn(dt, now);
    })(last);
  }

  /* ------------------------------------------------------------------ cart */
  CC.add = function (item, btn, mode) {
    var label = btn.innerHTML; btn.disabled = true; btn.classList.add('is-busy');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: item.variant, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (res) {
        if (mode === 'cart') { location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; return; }
        btn.classList.remove('is-busy'); btn.classList.add('is-added'); btn.innerHTML = btn.dataset.added || 'Added';
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: res, sourceId: 'contour-collection', data: { source: 'contour-collection' } } }));
        setTimeout(function () { btn.innerHTML = label; btn.disabled = false; btn.classList.remove('is-added'); }, 2200);
      })
      .catch(function () { btn.innerHTML = label; btn.disabled = false; btn.classList.remove('is-busy'); location.href = item.url; });
  };
  /* select a glass in the first explorer on the page; false if there isn't one */
  CC.select = function (handle) {
    for (var i = 0; i < CC.explorers.length; i++) if (CC.explorers[i].has(handle)) { CC.explorers[i].select(handle, true); return true; }
    return false;
  };
  var PLUS_ICON = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4v12M4 10h12"/></svg>';
  CC.PLUS_ICON = PLUS_ICON;
  /* pull the camera back on narrow (portrait) stages so the whole base stays in frame */
  function frame(cam) { var a = cam.aspect || 1; return a < 1.15 ? Math.min(1.75, 1.15 / a) : 1; }
  function fmtElev(item) { return item.elev ? Number(item.elev).toLocaleString('en-GB') + ' m' : ''; }
  function shortDesc(t) {
    if (!t) return '';
    t = String(t).replace(/\s+/g, ' ').trim().replace(/…$|\.\.\.$/, '');
    var parts = t.match(/[^.!?]+[.!?]+/g);
    if (!parts) return t;
    var out = ''; for (var i = 0; i < parts.length && (out + parts[i]).length < 240; i++) out += parts[i];
    return (out || parts[0]).trim();
  }

  /* ----------------------------------------------------------------- inits */
  var INIT = {};

  /* decorative contour lines (hero, closer) */
  INIT.contours = function (svg) {
    var t = new Terrain(svg.getAttribute('data-terrain'), 'decorative contours', 7);
    svg.removeAttribute('data-terrain');
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', t.contourPath(parseInt(svg.getAttribute('data-levels'), 10) || 14));
    p.setAttribute('fill', 'none'); p.setAttribute('stroke', 'currentColor'); p.setAttribute('stroke-width', '1'); p.setAttribute('vector-effect', 'non-scaling-stroke');
    svg.appendChild(p);
  };

  INIT.compare = function (el) {
    var box = el.querySelector('.cc-compare__box'), inp = box && box.querySelector('input');
    if (!inp) return;
    inp.addEventListener('input', function () { box.style.setProperty('--x', inp.value + '%'); });
    if (reduce) return;
    onScreen(box, function (v) {
      if (!v || box.__nudged) return; box.__nudged = true;
      var t0 = performance.now();
      (function n(now) { var p = Math.min(1, (now - t0) / 1400), x = 50 + Math.sin(p * Math.PI * 2) * 14 * (1 - p); inp.value = x; box.style.setProperty('--x', x + '%'); if (p < 1) requestAnimationFrame(n); })(t0);
    });
  };

  /* scroll story: contours -> terrain -> glass */
  INIT.story = function (el) {
    var state = { on: true, stopped: false };
    var stage = el.querySelector('.cc-story__stage'), canvas = el.querySelector('canvas');
    var steps = [].slice.call(el.querySelectorAll('.cc-step')), caps = [].slice.call(el.querySelectorAll('[data-cap]'));
    var t = new Terrain(el.getAttribute('data-terrain'), el.getAttribute('data-label') || 'story', 3);
    el.removeAttribute('data-terrain');
    var chapter = 0;
    function midLine() {
      var sr = stage.getBoundingClientRect();
      /* on phones the stage is pinned across the top: measure in the strip below it */
      if (sr.height < innerHeight * .8) { var below = Math.max(sr.bottom, 0); return below + (innerHeight - below) * .5; }
      return innerHeight * .55;
    }
    caps.forEach(function (c, i) {
      c.addEventListener('click', function () {
        var s = steps[i]; if (!s) return;
        var r = s.getBoundingClientRect();
        scrollByY(el, r.top + r.height / 2 - midLine());
      });
    });
    function upd() {
      if (steps.length < 3) return;
      var mid = midLine(), a = steps[0].getBoundingClientRect(), b = steps[2].getBoundingClientRect();
      var c0 = a.top + a.height / 2, c2 = b.top + b.height / 2;
      chapter = Math.max(0, Math.min(2, (mid - c0) / (c2 - c0) * 2));
      var act = Math.round(chapter);
      steps.forEach(function (s, i) { s.classList.toggle('is-active', i === act); });
      caps.forEach(function (c, i) { c.classList.toggle('is-on', i === act); });
    }
    var unScroll = onScroll(upd); upd();
    loadThree().then(function (THREE) {
      var r = renderer(THREE, canvas); if (!r) throw new Error('no webgl');
      var c = palette(el), scene = new THREE.Scene(), cam = new THREE.PerspectiveCamera(35, 1, .1, 100);
      var T = makeTerrain(THREE, heights(t), c); scene.add(T.group);
      var gH = 2.25, gu = { uAlpha: { value: 0 }, uC: { value: new THREE.Color(c.glass) } };
      var gm = new THREE.ShaderMaterial({ vertexShader: VS_GLASS, fragmentShader: FS_GLASS, uniforms: gu, transparent: true, depthWrite: false, side: THREE.DoubleSide });
      var glass = new THREE.Mesh(new THREE.CylinderGeometry(1.04, 1.04, gH, 96, 1, true), gm); glass.position.y = gH / 2 - .02; scene.add(glass);
      var slab = new THREE.Mesh(new THREE.CylinderGeometry(1.04, 1.04, .12, 96, 1, false), gm); slab.position.y = -.08; scene.add(slab);
      function ring(y) { var p = []; for (var i = 0; i <= 96; i++) { var a = i / 96 * Math.PI * 2; p.push(new THREE.Vector3(Math.cos(a) * 1.04, y, Math.sin(a) * 1.04)); } return new THREE.Line(new THREE.BufferGeometry().setFromPoints(p), new THREE.LineBasicMaterial({ color: new THREE.Color(c.glass), transparent: true, opacity: 0 })); }
      var rT = ring(gH - .02), rB = ring(-.14); scene.add(rT); scene.add(rB);
      var K = [
        { cam: [0, 3.6, .25], look: [0, 0, 0], amp: .03, contour: 1, fill: 0, lines: 0, glass: 0, ring: .5 },
        { cam: [2.6, 1.9, 2.6], look: [0, .15, 0], amp: .58, contour: .22, fill: 0, lines: .95, glass: 0, ring: .5 },
        { cam: [4.2, 3.1, 4.2], look: [0, .95, 0], amp: .44, contour: .14, fill: .55, lines: .3, glass: 1, ring: 0 }
      ];
      function L(a, b, k) { return a + (b - a) * k; }
      var shown = chapter, rot = 0;
      onScreen(stage, function (v) { state.on = v; });
      new ResizeObserver(function () { fit(r, cam, stage); }).observe(stage); fit(r, cam, stage);
      loop(state, function (dt) {
        upd();
        shown += (chapter - shown) * Math.min(1, dt * 4);
        var i = Math.min(1, Math.floor(shown)), k = shown - i; k = k * k * (3 - 2 * k);
        var a = K[i], b = K[i + 1];
        if (!reduce) rot += dt * (.12 + .25 * Math.min(1, shown));
        var cr = Math.cos(rot * .6), sr = Math.sin(rot * .6), px = L(a.cam[0], b.cam[0], k), py = L(a.cam[1], b.cam[1], k), pz = L(a.cam[2], b.cam[2], k);
        var fk = frame(cam);
        cam.position.set((px * cr - pz * sr) * fk, py * fk, (px * sr + pz * cr) * fk);
        cam.lookAt(L(a.look[0], b.look[0], k), L(a.look[1], b.look[1], k), L(a.look[2], b.look[2], k));
        T.shared.uAmp.value = L(a.amp, b.amp, k); T.fill.uContour.value = L(a.contour, b.contour, k); T.fill.uFill.value = L(a.fill, b.fill, k);
        T.line.uAlpha.value = L(a.lines, b.lines, k); T.ring.material.opacity = L(a.ring, b.ring, k);
        var g = L(a.glass, b.glass, k); gu.uAlpha.value = g; rT.material.opacity = rB.material.opacity = g * .55;
        r.render(scene, cam);
      });
    }).catch(function (e) { warn('3D unavailable: ' + (e && e.message || e)); el.classList.add('cc-nogl'); });
    return function () { state.stopped = true; unScroll(); };
  };

  /* 3D explorer + skyline */
  INIT.explorer = function (el) {
    var state = { on: true, stopped: false };
    var src = el.querySelector('[data-cc-items]'), items = (src && json(src)) || [];
    items = items.filter(function (p) { return p && p.handle; });
    if (!items.length) { warn('explorer: the chosen collection has no products'); return; }
    var by = {}; items.forEach(function (p, i) { p.i = i; by[p.handle] = p; });
    var mode = el.getAttribute('data-after-add') || 'stay';
    var q = function (s) { return el.querySelector(s); };
    var ui = { chips: q('[data-chips]'), meta: q('[data-meta]'), name: q('[data-name]'), desc: q('[data-desc]'), img: q('[data-img]'), title: q('[data-title]'), price: q('[data-price]'), add: q('[data-add]'), link: q('[data-link]'), elev: q('[data-elev]'), elevL: q('[data-elev-label]'), hint: q('[data-hint]'), stage: q('.cc-explore__stage'), canvas: q('.cc-explore__stage canvas'), fb: q('.cc-explore__fallback') };
    var summitLabel = el.getAttribute('data-summit-label') || 'Summit', heightLabel = el.getAttribute('data-height-label') || 'Height';
    function terrain(p) { if (!p._t) { p._t = new Terrain(p.terrain, p.name, p.i + 2); p.terrain = null; } return p._t; }
    items.forEach(function (p) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'cc-chip'; b.textContent = p.name; b.setAttribute('role', 'tab'); b.dataset.h = p.handle;
      b.addEventListener('click', function () { select(p.handle); }); ui.chips.appendChild(b);
    });
    var current = null, T = null;
    function info(p) {
      [].forEach.call(ui.chips.children, function (c) { var on = c.dataset.h === p.handle; c.classList.toggle('is-on', on); c.setAttribute('aria-selected', on); });
      ui.meta.textContent = [p.area || p.country, p.kind, p.isNew ? 'New' : ''].filter(Boolean).join(' · ');
      ui.name.textContent = p.name; ui.desc.textContent = shortDesc(p.desc);
      if (p.img) { ui.img.src = p.img; ui.img.alt = p.name; ui.img.hidden = false; } else ui.img.hidden = true;
      if (ui.fb && (p.img2 || p.img)) ui.fb.src = p.img2 || p.img;
      ui.title.textContent = p.name; ui.price.textContent = p.price || '';
      ui.link.href = p.url;
      ui.add.disabled = p.available === false;
      ui.add.hidden = p.available === false;
      ui.add.setAttribute('aria-label', (el.getAttribute('data-add-label') || 'Add to bag') + ': ' + p.name);
      ui.add.onclick = function () { CC.add(p, ui.add, mode); };
      var e = fmtElev(p); ui.elev.parentNode.hidden = !e; ui.elev.textContent = e;
      ui.elevL.textContent = /coast|cliff/i.test(p.kind || '') ? heightLabel : summitLabel;
    }
    var api = {
      has: function (h) { return !!by[h]; },
      select: select
    };
    CC.explorers.push(api);
    function select(h, scroll) {
      var p = by[h]; if (!p) return;
      if (current !== h) { current = h; info(p); if (T) T.morphTo(heights(terrain(p))); sky(h); }
      if (scroll) el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    /* skyline */
    var sky = function () {};
    var host = q('[data-skyline]');
    if (host) {
      var list = items.slice().sort(function (a, b) { return (b.elev || 0) - (a.elev || 0); });
      var maxE = Math.max.apply(null, list.map(function (p) { return p.elev || 0; })) || 1;
      var minFrac = .28, W = Math.max(720, list.length * 86), Hh = 240, top = 30, bot = 52, col = W / list.length, ns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(ns, 'svg'); svg.setAttribute('viewBox', '0 0 ' + W + ' ' + (Hh + bot)); svg.setAttribute('role', 'list');
      svg.style.minWidth = Math.min(W, list.length * 70) + 'px';
      var gl = document.createElementNS(ns, 'line'); gl.setAttribute('x1', 0); gl.setAttribute('x2', W); gl.setAttribute('y1', Hh); gl.setAttribute('y2', Hh); gl.setAttribute('class', 'cc-sky__ground'); svg.appendChild(gl);
      var nodes = {};
      list.forEach(function (p, i) {
        var prof = terrain(p).profile(40), cx = i * col + col / 2, w = col * .96, sc = (p.elev ? Math.max(minFrac, p.elev / maxE) : .45) * (Hh - top), pts = [];
        prof.forEach(function (h, k) { pts.push((cx - w / 2 + w * k / 40).toFixed(1) + ',' + (Hh - h * sc).toFixed(1)); });
        var g = document.createElementNS(ns, 'g'); g.setAttribute('class', 'cc-peak'); g.setAttribute('role', 'listitem'); g.setAttribute('tabindex', '0'); g.setAttribute('aria-label', p.name + (p.elev ? ', ' + fmtElev(p) : ''));
        var path = document.createElementNS(ns, 'path'); path.setAttribute('d', 'M' + (cx - w / 2) + ',' + Hh + ' L' + pts.join(' L') + ' L' + (cx + w / 2) + ',' + Hh + ' Z'); g.appendChild(path);
        var t1 = document.createElementNS(ns, 'text'); t1.setAttribute('x', cx); t1.setAttribute('y', Hh + 20); t1.setAttribute('text-anchor', 'middle'); t1.textContent = p.name.replace(/^The /, ''); g.appendChild(t1);
        var t2 = document.createElementNS(ns, 'text'); t2.setAttribute('x', cx); t2.setAttribute('y', Hh + 38); t2.setAttribute('text-anchor', 'middle'); t2.setAttribute('class', 'cc-sky__elev'); t2.textContent = fmtElev(p); g.appendChild(t2);
        function go() { select(p.handle); var st = el.querySelector('.cc-explore__grid'); if (st && st.getBoundingClientRect().top < 0) st.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
        g.addEventListener('click', go); g.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
        svg.appendChild(g); nodes[p.handle] = g;
      });
      host.appendChild(svg);
      sky = function (h) { for (var k in nodes) nodes[k].classList.toggle('is-on', k === h); };
    }

    var first = el.getAttribute('data-default');
    select(by[first] ? first : items[0].handle);

    loadThree().then(function (THREE) {
      var r = renderer(THREE, ui.canvas); if (!r) throw new Error('no webgl');
      var c = palette(el), scene = new THREE.Scene(), cam = new THREE.PerspectiveCamera(34, 1, .1, 100);
      T = makeTerrain(THREE, heights(terrain(by[current])), c); scene.add(T.group);
      T.shared.uAmp.value = .55; T.line.uAlpha.value = 1; T.fill.uFill.value = .22;
      var rotY = .6, rotX = .42, vY = 0, drag = false, lx = 0, ly = 0, idle = 0;
      new ResizeObserver(function () { fit(r, cam, ui.stage); }).observe(ui.stage); fit(r, cam, ui.stage);
      onScreen(ui.stage, function (v) { state.on = v; });
      ui.stage.addEventListener('pointerdown', function (e) { drag = true; lx = e.clientX; ly = e.clientY; if (ui.hint) ui.hint.style.opacity = 0; try { ui.stage.setPointerCapture(e.pointerId); } catch (x) {} });
      ui.stage.addEventListener('pointermove', function (e) { if (!drag) return; var dx = e.clientX - lx, dy = e.clientY - ly; lx = e.clientX; ly = e.clientY; vY = dx * .008; rotY += vY; rotX = Math.max(.12, Math.min(1.25, rotX + dy * .005)); idle = 0; });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (n) { ui.stage.addEventListener(n, function () { drag = false; }); });
      loop(state, function (dt) {
        idle += dt;
        if (!drag) { vY *= .92; rotY += vY; if (idle > 1.5 && !reduce) rotY += dt * .22; }
        if (T.shared.uMix.value < 1) T.shared.uMix.value = Math.min(1, T.shared.uMix.value + dt * 1.6);
        var d = 4.3 * frame(cam); cam.position.set(Math.sin(rotY) * Math.cos(rotX) * d, Math.sin(rotX) * d + .1, Math.cos(rotY) * Math.cos(rotX) * d); cam.lookAt(0, .18, 0);
        r.render(scene, cam);
      });
    }).catch(function (e) { warn('3D unavailable: ' + (e && e.message || e)); el.classList.add('cc-nogl'); });
    return function () { state.stopped = true; var i = CC.explorers.indexOf(api); if (i > -1) CC.explorers.splice(i, 1); };
  };

  /* product grid */
  INIT.grid = function (el) {
    var src = el.querySelector('[data-cc-items]'), items = (src && json(src)) || [];
    items = items.filter(function (p) { return p && p.handle; });
    items.forEach(function (p, i) { p.i = i; });
    var grid = el.querySelector('[data-grid]'), count = el.querySelector('[data-count]'), kinds = el.querySelector('[data-kinds]'), country = el.querySelector('[data-country]'), sort = el.querySelector('[data-sort]');
    var mode = el.getAttribute('data-after-add') || 'stay', addLabel = el.getAttribute('data-add-label') || 'Add to bag', show3d = el.getAttribute('data-show-3d') !== 'false';
    var st = { kind: 'all', country: 'all', sort: 'feat' };
    function uniq(k) { var s = {}; items.forEach(function (p) { if (p[k]) s[p[k]] = 1; }); return Object.keys(s); }
    if (kinds) {
      var ks = uniq('kind');
      if (ks.length > 1) {
        ks.forEach(function (k) { var b = document.createElement('button'); b.type = 'button'; b.className = 'cc-chip'; b.dataset.kind = k; b.textContent = k; kinds.appendChild(b); });
        kinds.addEventListener('click', function (e) { var b = e.target.closest('[data-kind]'); if (!b) return; st.kind = b.dataset.kind; [].forEach.call(kinds.children, function (x) { x.classList.toggle('is-on', x === b); }); render(); });
      } else kinds.hidden = true;
    }
    if (country) {
      var cs = uniq('country');
      if (cs.length > 1) { cs.forEach(function (c) { var o = document.createElement('option'); o.value = c; o.textContent = c; country.appendChild(o); }); country.addEventListener('change', function () { st.country = country.value; render(); }); }
      else country.hidden = true;
    }
    if (sort) sort.addEventListener('change', function () { st.sort = sort.value; render(); });
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function render() {
      var l = items.filter(function (p) { return (st.kind === 'all' || p.kind === st.kind) && (st.country === 'all' || p.country === st.country); });
      if (st.sort === 'high') l.sort(function (a, b) { return (b.elev || 0) - (a.elev || 0); });
      else if (st.sort === 'az') l.sort(function (a, b) { return a.name.replace(/^The /, '').localeCompare(b.name.replace(/^The /, '')); });
      else l.sort(function (a, b) { return a.i - b.i; });
      grid.innerHTML = '';
      var has3d = show3d && CC.explorers.length > 0;
      l.forEach(function (p, i) {
        var c = document.createElement('article'); c.className = 'cc-card'; c.style.animationDelay = (i * 35) + 'ms';
        var e = fmtElev(p), place = esc(p.area || p.country || '') + (e ? (p.area || p.country ? ' · ' : '') + '<span class="cc-nowrap">' + esc(e) + '</span>' : '');
        c.innerHTML = '<div class="cc-card__media"><a class="cc-card__img" href="' + esc(p.url) + '" tabindex="-1">' + (p.isNew ? '<span class="cc-badge">New</span>' : '') +
          (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.name) + '" loading="lazy">' : '') + (p.img2 ? '<img src="' + esc(p.img2) + '" alt="" loading="lazy" aria-hidden="true">' : '') + '</a>' +
          (has3d ? '<button class="cc-3d" type="button" aria-label="Turn ' + esc(p.name) + ' in 3D">◐ 3D</button>' : '') +
          (p.available === false ? '<span class="cc-card__soldout">' + esc(el.getAttribute('data-soldout') || 'Sold out') + '</span>'
            : '<button class="cc-plus" type="button" data-added="&#10003;" aria-label="' + esc(addLabel + ': ' + p.name) + '">' + PLUS_ICON + '</button>') + '</div>' +
          '<div class="cc-card__body"><div class="cc-card__row"><a class="cc-card__name" href="' + esc(p.url) + '">' + esc(p.name) + '</a><span class="cc-card__price">' + esc(p.price) + '</span></div>' +
          (place ? '<div class="cc-card__place">' + place + '</div>' : '') + '</div>';
        var b3 = c.querySelector('.cc-3d'); if (b3) b3.addEventListener('click', function () { if (!CC.select(p.handle)) location.href = p.url; });
        var add = c.querySelector('.cc-plus'); if (add) add.addEventListener('click', function () { CC.add(p, add, mode); });
        grid.appendChild(c);
      });
      if (!l.length) grid.innerHTML = '<p class="cc-empty">Nothing matches those filters yet.</p>';
      if (count) count.textContent = l.length + (l.length === 1 ? ' place' : ' places');
    }
    render();
    /* explorers may initialise after the grid; redraw once so the 3D buttons appear */
    setTimeout(render, 0);
  };

  /* ------------------------------------------------------------------ scan */
  var STOPS = [];
  CC.scan = function (root) {
    [].forEach.call((root || document).querySelectorAll('[data-cc]'), function (el) {
      if (el.__cc) return; el.__cc = true;
      var f = INIT[el.getAttribute('data-cc')]; if (!f) return;
      try { var stop = f(el); if (stop) STOPS.push({ el: el, stop: stop }); } catch (e) { warn(e && e.message); }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { CC.scan(document); });
  else CC.scan(document);
  /* theme editor: re-initialise a section when its settings change */
  document.addEventListener('shopify:section:load', function (e) { CC.scan(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    STOPS = STOPS.filter(function (s) { if (e.target.contains(s.el)) { s.stop(); return false; } return true; });
  });
})();
